class ShowHideFilter extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.showLabel = this.querySelector('.show-filter-label');
    this.hideLabel = this.querySelector('.hide-filter-label');
    this.isDisplayed = true;
    this.localStorageKey = 'showHideFilterState';

    this.productGrid = document.querySelector('#product-grid');


    this.leftDesktopLayout = document.querySelector('.facets-vertical');
    this.leftDesktopFilters = this.leftDesktopLayout.querySelector('.facet-filters');

    this.limitLayout = true;

    this.layoutSixColumnClass = 'grid--6-col-desktop';
    this.layoutFifthColumnClass = 'grid--5-col-desktop';
    this.layoutFourColumnClass = 'grid--4-col-desktop';
    this.layoutThreeColumnClass = 'grid--3-col-desktop';

    this.dontRevert = false;

    if (!this.button || !this.showLabel || !this.hideLabel) {
      return;
    }

    this.loadState();
    this.init();
  }

  loadState() {
    const savedState = localStorage.getItem(this.localStorageKey);

    if (savedState !== null) {

      this.isDisplayed = savedState === 'true';

      if (!this.isDisplayed) {
        this.leftDesktopFilters.classList.add('hide-filters');
        this.showLabel.classList.remove('hidden');
        this.hideLabel.classList.add('hidden');

        setTimeout(() => {
          this.changeLayout();
        }, 0)
     
      } else {
        this.leftDesktopFilters.classList.remove('hide-filters');
        this.showLabel.classList.add('hidden');
        this.hideLabel.classList.remove('hidden');
        this.leftDesktopLayout.classList.remove('hideFilters');
      }
    }
  }

  saveState() {
    localStorage.setItem(this.localStorageKey, this.isDisplayed);
  }

  changeLayout() {
    const productGrid = document.querySelector('#product-grid');
    this.leftDesktopLayout.classList.add('hideFilters');

    if (productGrid.classList.contains(this.layoutThreeColumnClass)) {
      productGrid.classList.remove(this.layoutThreeColumnClass);
      productGrid.classList.add(this.layoutFourColumnClass);

      this.limitLayout = false;

      return;
    }

    if (productGrid.classList.contains(this.layoutFourColumnClass)) {
      productGrid.classList.remove(this.layoutFourColumnClass);
      productGrid.classList.add(this.layoutFifthColumnClass);

      this.limitLayout = false;

      return;
    }

    if (productGrid.classList.contains(this.layoutFifthColumnClass)) {
      productGrid.classList.remove(this.layoutFifthColumnClass);
      productGrid.classList.add(this.layoutSixColumnClass);

      this.limitLayout = false;
    }

  }

  reverChangeLayout() {
    this.leftDesktopLayout.classList.remove('hideFilters');

    const productGrid = document.querySelector('#product-grid');

    if (productGrid.classList.contains(this.layoutSixColumnClass)) {
      productGrid.classList.remove(this.layoutSixColumnClass);
      productGrid.classList.add(this.layoutFifthColumnClass);

      return;
    }

    if (productGrid.classList.contains(this.layoutFifthColumnClass)) {
      productGrid.classList.remove(this.layoutFifthColumnClass);
      productGrid.classList.add(this.layoutFourColumnClass);

      return;
    }

    if (productGrid.classList.contains(this.layoutFourColumnClass)) {
      productGrid.classList.remove(this.layoutFourColumnClass);
      productGrid.classList.add(this.layoutThreeColumnClass);

      return;
    }
  }

  init() {
    this.button.addEventListener('click', (event) => {
      event.preventDefault();

      if (this.isDisplayed) {
        this.leftDesktopFilters.classList.add('hide-filters');
        this.showLabel.classList.remove('hidden');
        this.hideLabel.classList.add('hidden');

        this.changeLayout();
      } else {
        this.leftDesktopFilters.classList.remove('hide-filters');
        this.showLabel.classList.add('hidden');
        this.hideLabel.classList.remove('hidden');

        this.reverChangeLayout();
      }

      this.isDisplayed = !this.isDisplayed;
      this.saveState();
    });

    document.addEventListener('layout::changed', () => {
      if (this.isDisplayed === true) {
        return;
      }

      this.changeLayout();
    });
  }
}

customElements.define('show-hide-filter', ShowHideFilter);